/* eslint-disable no-tabs */
import Vue from 'vue';
import Router from 'vue-router';
import Artical from './views/Artical.vue';
import Home from './views/Home.vue';
import Message from './views/Message.vue';
import MljyMessage from './views/MljyMessage.vue';
import Reimbursement from './views/Reimbursement.vue';
import ReimbursementList from './views/ReimbursementList.vue';
import RedirectPage from './views/RedirectPage.vue';
Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/message',
		name: 'message',
		component: Message
	},
	{
		path: '/mljy_message',
		name: 'mljy-message',
		component: MljyMessage
	},
	{
		path: '/artical/:source/:id',
		name: 'artical',
		component: Artical
	},
	{
		path: '/reimbursement/list',
		name: 'reimbursement-list',
		component: ReimbursementList
	},
	{
		path: '/reimbursement',
		name: 'reimbursement',
		component: Reimbursement
	},
	{
		path: '/redirectpage',
		name: 'redirectpage',
		component: RedirectPage
	}]
});
